import { auth } from "@/firebase";
import { authStateAtom } from "@/orm/auth";
import { Button, Stack, Text } from "@mantine/core";
import { useAtomValue } from "jotai";
import { useSignOut } from "react-firebase-hooks/auth";

export const Actions = () => {
  const { user } = useAtomValue(authStateAtom);
  const [signout] = useSignOut(auth);

  return (
    <Stack>
      <Stack gap={4}>
        <Text size="xs">User Created: {user?.metadata.creationTime}</Text>
        <Text size="xs">User UUID: {user?.uid}</Text>
      </Stack>
      <Button variant="outline" onClick={signout} radius={999}>
        Log out
      </Button>
    </Stack>
  );
};
